import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import clientinvoiceApiController from "../../services/clientinvoice.service";
import invoiceActivityApiController from "../../services/invoiceActivity.service";
import { normalizeClientInvoiceResponse } from "../../services/clientInvoiceContract";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";

export const ClientInvoiceListViewApi = createAsyncThunk("clientinvoice/listview", async (formValues, thunkAPI) => {
  const listState = thunkAPI.getState().clientinvoice;
  formValues = { ...formValues, category: formValues?.category ||
    (listState?.invoiceClientId === Number(formValues?.client_id) ? listState.invoiceCategory : null) || "completed" };
  try {
    const resposedata = await clientinvoiceApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, { ...response, data: normalizeClientInvoiceResponse(response.data, formValues) }, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientInvoiceDetailApi = createAsyncThunk("clientinvoice/detailview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientinvoiceApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, { ...response, data: normalizeClientInvoiceResponse(response.data, formValues) }, "detailview"))
      .catch((error) => HandleError(thunkAPI, error, "detailview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientHideInvoiceApi = createAsyncThunk("clientinvoice/hideinvoice", async (formValues, thunkAPI) => {
  try {
    const response = await clientinvoiceApiController.hideInvoice(formValues, thunkAPI);
    const adminFlag = ["true", "1", "yes"].includes(String(localStorage.getItem("ADMIN") || "").toLowerCase());
    return HandleResponse(thunkAPI, { ...response, data: {
      ...response.data,
      id: formValues && formValues.id ? formValues.id : undefined,
      is_active: formValues && formValues.is_active !== undefined ? formValues.is_active : 0,
      adminClientInvoice: adminFlag,
    } });
  } catch (error) {
    return HandleError(thunkAPI, error, "hideinvoice");
  }
});

export const SaleActivityApi = createAsyncThunk("clientinvoice/activity", async (formValues, thunkAPI) => {
  try {
    // The sale/activity route is capability-gated and tenant-scoped, so the
    // client sends the sale id and nothing else.
    const id = formValues && formValues.id ? Number(formValues.id) : undefined;
    const response = await invoiceActivityApiController.invoiceActivity({ sale_id: id });
    if (!Array.isArray(response?.data?.activity)) {
      return thunkAPI.rejectWithValue("Invoice activity response was invalid.");
    }
    return { ...response.data, id };
  } catch (error) {
    return HandleError(thunkAPI, error);
  }
});

const initialState = {
  invoiceClientId: null,
  invoiceCategory: "completed",
  listRequestId: null,
  detailRequestId: null,
  isListView: [],
  isListViewError: "",
  isVisibilityError: "",
  isOpenClientInvoiceDetailsTab: "",
  isClientInvoiceDetailsTabData: "",
  isOpenClientInvoiceRefundModal: "",
  isOpenClientInvoiceStripePayModalClient: "",
  isOpenStripeRefundCompletedSaleModal: "",
  isCompletedSaleDataForRefund: "",
  isdepositBalance: "",
  isSaleCompletedData: "",
  AppointmentsData: "",
  appointmentsArray: "",
  isOpenPartialPaidInvoice: "",
  isActiveBtnState: "",
  saleActivity: {},
  isRefundStripeToken: "",
  isOpenStripeRefundModal: "",
  isRefundBalance: "",
  isTaxAmountClientPaidInvoice: "",
  isClientMemberShipTotalPay: "",
  totalServiceCosts: "",
  isFullCartData: "",
  isClientInvoiceDetail: "",
  isApiStatus: {
    ClientInvoiceListViewApi: "",
    ClientInvoiceDetailApi: "",
    ClientHideInvoiceApi: "",
  },
};

const clearInvoiceDetails = (state) => {
  state.detailRequestId = null;
  state.isClientInvoiceDetail = "";
  state.isClientInvoiceDetailsTabData = "";
  state.isOpenClientInvoiceDetailsTab = "";
  state.isOpenPartialPaidInvoice = "";
  state.isOpenClientInvoiceRefundModal = "";
  state.isOpenClientInvoiceStripePayModalClient = "";
  state.isOpenStripeRefundCompletedSaleModal = "";
  state.saleActivity = {};
};
const scopeInvoices = (state, clientId) => {
  if (state.invoiceClientId === clientId) return;
  state.invoiceClientId = clientId;
  state.invoiceCategory = "completed";
  state.listRequestId = null;
  state.isListView = [];
  state.isListViewError = "";
  state.isVisibilityError = "";
  clearInvoiceDetails(state);
};
const ownsRequest = (state, action, key) =>
  state[key] === action.meta.requestId && state.invoiceClientId === Number(action.meta.arg?.client_id);

const clientinvoiceSlice = createSlice({
  name: "clientinvoice",
  initialState,
  reducers: {
    reset: () => initialState,
    ScopeClientInvoices: (state, action) => scopeInvoices(state, Number(action.payload) || null),
    OpenClientInvoiceDetails: (state, action) => {
      state.isOpenClientInvoiceDetailsTab = action.payload;
    },
    GetClientDetailTabInvoiceData: (state, action) => {
      state.isClientInvoiceDetailsTabData = action.payload;
      state.isClientInvoiceDetail = action.payload;
    },
    OpenClientInvoiceRefundModal: (state, action) => {
      state.isOpenClientInvoiceRefundModal = action.payload;
    },
    OpenClientInvoiceStripePayModalClient: (state, action) => {
      state.isOpenClientInvoiceStripePayModalClient = action.payload;
    },
    ClientInvoiceRefundData: (state, action) => {
      state.isSaleCompletedData = action.payload.isSaleCompletedData;
      state.AppointmentsData = action.payload.AppointmentsData;
      state.isRefundBalance = action.payload.balance;
    },
    OpenPartialPaidInvoice: (state, action) => {
      state.isOpenPartialPaidInvoice = action.payload;
    },
    ActiveBtnState: (state, action) => {
      state.isActiveBtnState = action.payload;
    },
    RefundStripeToken: (state, action) => {
      state.isRefundStripeToken = action.payload;
    },
    OpenStripeRefundModal: (state, action) => {
      state.isOpenStripeRefundModal = action.payload;
    },
    OpenStripeRefundCompletedSaleModal: (state, action) => {
      state.isOpenStripeRefundCompletedSaleModal = action.payload;
    },
    CompletedSaleDataForRefund: (state, action) => {
      state.isCompletedSaleDataForRefund = action.payload.isSaleCompletedData;
      state.appointmentsArray = action.payload.appointmentsArray;
      state.isdepositBalance = action.payload.isdepositBalance;
      state.isFullCartData = action.payload.FullCartData;
    },
    TaxAmountClientPaidInvoice: (state, action) => {
      state.isTaxAmountClientPaidInvoice = action.payload.taxAmounts;
      state.totalServiceCosts = action.payload.totalServiceCosts;
    },
    ClientMemberShipTotalPay: (state, action) => {
      state.isClientMemberShipTotalPay = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ClientInvoiceDetailApi.pending, (state, action) => {
        scopeInvoices(state, Number(action.meta.arg?.client_id));
        clearInvoiceDetails(state);
        state.detailRequestId = action.meta.requestId;
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceDetailApi: "loading" };
      })
      .addCase(ClientInvoiceDetailApi.fulfilled, (state, action) => {
        if (!ownsRequest(state, action, "detailRequestId")) return;
        state.isClientInvoiceDetail = action.payload;
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceDetailApi: "succeeded" };
      })
      .addCase(ClientInvoiceDetailApi.rejected, (state, action) => {
        if (!ownsRequest(state, action, "detailRequestId")) return;
        state.isClientInvoiceDetail = [];
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceDetailApi: "failed" };
      })
      .addCase(ClientInvoiceListViewApi.pending, (state, action) => {
        scopeInvoices(state, Number(action.meta.arg?.client_id));
        const category = action.meta.arg?.category || state.invoiceCategory || "completed";
        if (category !== state.invoiceCategory) {
          state.isListView = [];
          clearInvoiceDetails(state);
        }
        state.invoiceCategory = category;
        state.listRequestId = action.meta.requestId;
        if (!action.meta.arg?.next_page_url) state.isListView = [];
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceListViewApi: "loading" };
        state.isListViewError = "";
      })
      .addCase(ClientInvoiceListViewApi.fulfilled, (state, action) => {
        if (!ownsRequest(state, action, "listRequestId")) return;
        const previous = state.isListView;
        const isNextPage = Boolean(action.meta.arg?.next_page_url) && previous && previous.current_page < action.payload.current_page;
        state.isListView = isNextPage && Array.isArray(previous.data) && Array.isArray(action.payload.data)
          ? { ...action.payload, data: [...previous.data, ...action.payload.data] }
          : action.payload;
        state.isListViewError = "";
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceListViewApi: "succeeded" };
      })
      .addCase(ClientInvoiceListViewApi.rejected, (state, action) => {
        if (!ownsRequest(state, action, "listRequestId")) return;
        state.isApiStatus = { ...state.isApiStatus, ClientInvoiceListViewApi: "failed" };
        state.isListViewError = contentErrorMessage(action, "Unable to load invoices.");
      })
      .addCase(ClientHideInvoiceApi.pending, (state) => {
        state.isVisibilityError = "";
        state.isApiStatus = { ...state.isApiStatus, ClientHideInvoiceApi: "loading" };
      })
      .addCase(ClientHideInvoiceApi.fulfilled, (state, action) => {
        if (action.meta.arg?.client_id && Number(action.meta.arg.client_id) !== state.invoiceClientId) return;
        const invoiceId = action.payload && action.payload.id;
        const targetActiveState = action.payload && action.payload.is_active;
        const isAdminList = action.payload && action.payload.adminClientInvoice;
        if (state.isListView && state.isListView.data && invoiceId) {
          if (targetActiveState === 0 || targetActiveState === "0") {
            if (isAdminList) {
              state.isListView.data = state.isListView.data.map((item) =>
                item.id === invoiceId ? { ...item, is_active: 0 } : item
              );
            } else {
              state.isListView.data = state.isListView.data.filter((item) => item.id !== invoiceId);
            }
          } else {
            state.isListView.data = state.isListView.data.map((item) =>
              item.id === invoiceId ? { ...item, is_active: 1 } : item
            );
          }
        }
        state.isApiStatus = { ...state.isApiStatus, ClientHideInvoiceApi: "succeeded" };
      })
      .addCase(ClientHideInvoiceApi.rejected, (state, action) => {
        if (action.meta.arg?.client_id && Number(action.meta.arg.client_id) !== state.invoiceClientId) return;
        state.isApiStatus = { ...state.isApiStatus, ClientHideInvoiceApi: "failed" };
        state.isVisibilityError = contentErrorMessage(action, "Unable to update this invoice.");
      })
      .addCase(SaleActivityApi.pending, (state, action) => {
        const id = action.meta && action.meta.arg ? Number(action.meta.arg.id) : NaN;
        if (Number.isInteger(id)) {
          state.saleActivity = { ...state.saleActivity, [id]: { entries: [], status: "loading" } };
        }
      })
      .addCase(SaleActivityApi.fulfilled, (state, action) => {
        const id = action.payload && action.payload.id;
        if (Number.isInteger(id)) {
          state.saleActivity = {
            ...state.saleActivity,
            [id]: { entries: Array.isArray(action.payload.activity) ? action.payload.activity : [], status: "succeeded" },
          };
        }
      })
      .addCase(SaleActivityApi.rejected, (state, action) => {
        const id = action.meta && action.meta.arg ? Number(action.meta.arg.id) : NaN;
        if (Number.isInteger(id)) {
          state.saleActivity = { ...state.saleActivity, [id]: { entries: [], status: "failed" } };
        }
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset, ScopeClientInvoices, openNoteDrawer, closeNoteDrawer, openAddNoteForm, closeAddNoteForm, openEditNoteForm, closeEditNoteForm, OpenClientInvoiceDetails, GetClientDetailTabInvoiceData, OpenClientInvoiceRefundModal, OpenClientInvoiceStripePayModalClient, ClientInvoiceRefundData, OpenPartialPaidInvoice, ActiveBtnState, RefundStripeToken, OpenStripeRefundModal, OpenStripeRefundCompletedSaleModal, CompletedSaleDataForRefund, TaxAmountClientPaidInvoice, ClientMemberShipTotalPay } = clientinvoiceSlice.actions;
export default clientinvoiceSlice.reducer;

export const selectSaleActivity = (state, saleId) => {
  const id = Number(saleId);
  const stored = Number.isInteger(id) ? state.clientinvoice.saleActivity[id] : undefined;
  return stored && Array.isArray(stored.entries) ? stored.entries : [];
};
